"use client";

import React, { useEffect, useState } from "react";
import Link from "next/link";

/** Appears after 50% scroll and hides while #book-a-demo is in view. No slide animation. */
export function EmployeeCommunicationStickyCta() {
  const [pastThreshold, setPastThreshold] = useState(false);
  const [formVisible, setFormVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const denom = document.body.scrollHeight - window.innerHeight;
      const depth = denom > 0 ? window.scrollY / denom : 0;
      setPastThreshold(depth > 0.5);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const form = document.getElementById("book-a-demo");
    if (!form || !("IntersectionObserver" in window)) return;
    const observer = new IntersectionObserver(
      entries => setFormVisible(entries[0]?.isIntersecting ?? false),
      { threshold: 0.2 }
    );
    observer.observe(form);
    return () => observer.disconnect();
  }, []);

  if (!pastThreshold || formVisible || dismissed) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-50 border-t border-white/10 bg-[#12224F] shadow-[0_-12px_40px_-20px_rgba(0,0,0,0.5)]"
      data-lead="employee-communication-app-sticky"
    >
      <div className="mx-auto flex max-w-[1240px] flex-wrap items-center justify-between gap-4 px-5 py-3.5 md:px-10">
        <p className="text-sm font-medium text-[#EAEFFB] md:text-base">
          Your next company-wide announcement can reach every screen, desktop, and phone in one
          push, not a resend cycle.
        </p>
        <div className="ml-auto flex items-center gap-3">
          <Link
            href="#book-a-demo"
            className="inline-flex min-h-11 items-center whitespace-nowrap rounded-lg bg-accent px-5 text-sm font-semibold text-white hover:opacity-90"
          >
            Request a Demo
          </Link>
          <button
            type="button"
            onClick={() => setDismissed(true)}
            className="min-h-11 px-1 text-2xl leading-none text-[#8FA0C6]"
            aria-label="Close"
          >
            ×
          </button>
        </div>
      </div>
    </div>
  );
}
